import React from "react";
import longMessage from "../../../macros/longMessage.macro";
const Path = ({ children, ...otherProps }) => (<path d={children.join("\n")} {...otherProps}/>);
export const ICONS = {
    ARROW_LEFT: (<g>
			<path d="M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"/>
			<path d="M0-.5h24v24H0z" fill="none"/>
		</g>),
    ARROW_RIGHT: (<g>
			<path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"/>
			<path d="M0-.25h24v24H0z" fill="none"/>
		</g>),
    CLOSE: (<g>
			<Path>
				{[
        "M57.5,50l41-41c2.1-2.1,2.1-5.4,0-7.5c-2.1-2.1-5.4-2.1-7.5,",
        "0l-41,41L9,1.5C7-0.5,3.6-0.5,1.5,1.5C-0.5,3.6-0.5,7,1.5,9l41,41l-41,",
        "41c-2.1,2.1-2.1,5.4,0,7.5c1,1,2.4,1.5,3.7,1.5S8,99.5,9,98.5l41-41l41,",
        "41c1,1,2.4,1.5,3.7,1.5s2.7-0.5,3.7-1.5c2.1-2.1,2.1-5.4,0-7.5L57.5,50z"
    ]}
			</Path>
		</g>),
    EDIT: (<g>
			<Path>
				{[
        "M0,79.2V100h20.8l61.4-61.4L61.4,17.7C61.4,17.7,0,79.2,0,79.2z M98.4,",
        "22.5c2.2-2.2,2.2-5.7,0-7.8l-13-13c-2.2-2.2-5.7-2.2-7.8,0L67.4,11.8l20.8,",
        "20.8C88.2,32.6,98.4,22.5,98.4,22.5z"
    ]}
			</Path>
		</g>),
    EMAIL_OPT_OUT: (<g>
			
			<path d="M19 9.062s-5.188-.333-7 1.938c2-4.896 7-5.938 7-5.938v-2l5 4-5 4.019v-2.019zm-18.974 14.938h23.947l-11.973-11.607-11.974 11.607zm1.673-14l10.291-7.488 3.053 2.218c.712-.459 1.391-.805 1.953-1.054l-5.006-3.637-11.99 8.725v12.476l7.352-7.127-5.653-4.113zm15.753 4.892l6.548 6.348v-11.612l-6.548 5.264z"/>
		</g>),
    EVENT: (<g>
			<Path>
				{[
        "M77.8,61.1H50v27.8h27.8V61.1z M72.2,",
        "0v11.1H27.8V0H16.7v11.1h-5.6c-6.2,0-11.1,5-11.1,11.1L0,100c0,6.1,4.9,11.1,11.1,",
        "11.1h77.8c6.1,0,11.1-5,11.1-11.1V22.2c0-6.1-5-11.1-11.1-11.1h-5.6V0H72.2z M88.9,",
        "100H11.1V38.9h77.8V100z"
    ]}
			</Path>
		</g>),
    HOME: (<g>
			<path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
			<path d="M0 0h24v24H0z" fill="none"/>
		</g>),
    LOADING: (<g>
			<Path>
				{[
        "M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7",
        "14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0",
        "3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z"
    ]}
			</Path>
			<path d="M0 0h24v24H0z" fill="none"/>
		</g>),
    LOGOUT: (<g>
			<Path>
				{[
        "M80.1,80.4l1.8-1.8h9.2c-4.6,6.6-10.5,11.8-17.7,15.6c-7.2,",
        "3.9-15,5.8-23.3,5.8c-13.8,0-25.6-4.9-35.4-14.6C4.9,75.6,0,63.8,0,",
        "50s4.9-25.6,14.6-35.4C24.4,4.9,36.2,0,50,0c8.3,0,16.1,1.9,23.3,5.8c7.2,",
        "3.9,13.1,9.1,17.7,15.6h-9.2l-1.8-1.8C71.8,11.3,61.8,7.1,50,7.1c-11.9,0-22,",
        "4.2-30.4,12.5C11.3,28,7.1,38.1,7.1,50c0,11.9,4.2,22,12.5,30.4C28,88.7,",
        "38.1,92.9,50,92.9C61.8,92.9,71.8,88.7,80.1,80.4z M74.8,",
        "65.2l11.6-11.6H35.7v-7.1h50.7L74.8,34.8l4.9-5.1L100,50L79.7,70.3L74.8,65.2z"
    ]}
			</Path>
		</g>),
    PHONE: (<g>
			<path d="M0 0h24v24H0z" fill="none"/>
			<Path>
				{[
        "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24",
        "1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1",
        "1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
    ]}
			</Path>
		</g>),
    PROFILE: (<g>
			<Path>
				{[
        "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67",
        "0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
    ]}
			</Path>
			<path d="M0 0h24v24H0z" fill="none"/>
		</g>),
    COURT: (<g>
			<rect x="151" y="340" width="211" height="12"/>
			<rect x="160" y="319" width="193" height="12"/>
			<polygon points="277,226 277,216 236,216 236,226 243,226 243,297 236,297 236,309 277,309 277,297 270,297 270,226"/>
			<polygon points="338,226 338,216 297,216 297,226 306,226 306,297 297,297 297,309 338,309 338,297 332,297 332,226"/>
			<polygon points="216,226 216,216 175,216 175,226 181,226 181,297 175,297 175,309 216,309 216,297 207,297 207,226"/>
			<polygon points="353,190.3 256.5,128.5 160,190.3 160,202 353,202 	"/>
		</g>),
    DOCUMENTS: (<g transform="translate(0.000000,486.000000) scale(0.100000,-0.100000)">
			<Path>
				{[
        "M592 4250 l-592 -610 2 -1668 3 -1667 33 -67 c38 -77 131 -171 208",
        "-209 l49 -24 1584 -3 1585 -2 60 28 c91 43 168 119 213 210 l38 76 0 2116 0",
        "2116 -38 76 c-44 91 -121 167 -212 210 l-60 28 -1140 0 -1140 0 -593 -610z",
        "m2803 295 c20 -8 38 -22 42 -32 4 -10 13 -24 20 -31 19 -20 19 -4084 0 -4104",
        "-7 -7 -16 -21 -20 -31 -18 -48 26 -47 -1554 -47 -1449 0 -1479 0 -1510 20 -19",
        "11 -41 38 -53 64 -20 45 -20 56 -20 1535 l0 1490 503 3 c574 3 548 0 586 87",
        "21 49 21 61 21 555 l0 506 975 0 c831 0 981 -2 1010 -15z m-2295 -520 l0 -305",
        "-297 1 -298 0 54 47 c72 62 161 149 136 131 -35 -25 132 154 207 221 40 36 99",
        "97 131 137 32 40 60 73 63 73 2 0 4 -137 4 -305z"
    ]}
			</Path>
			<Path>
				{[
        "M754 3006 c-102 -45 -117 -204 -26 -274 l35 -27 1110 -3 1110 -2 44",
        "21 c59 29 87 82 81 156 -5 62 -29 100 -79 125 -32 17 -106 18 -1139 18 -902",
        "-1 -1111 -3 -1136 -14z"
    ]}
			</Path>
			<Path>
				{[
        "M733 2160 c-89 -54 -89 -206 0 -260 31 -19 59 -20 1152 -20 1046 0",
        "1122 1 1155 18 89 44 93 210 7 262 -31 20 -56 20 -1157 20 -1098 0 -1126 -1",
        "-1157 -20z"
    ]}
			</Path>
			<Path>
				{[
        "M736 1321 c-22 -10 -41 -25 -42 -32 -2 -8 -10 -34 -19 -59 -15 -42",
        "-14 -49 3 -105 32 -103 -80 -94 1204 -95 829 0 1124 3 1145 12 15 6 32 12 36",
        "12 4 1 17 21 27 45 35 77 21 159 -35 211 l-27 25 -1126 2 c-1081 2 -1129 2",
        "-1166 -16z"
    ]}
			</Path>
		</g>),
    CHAT: (<path d="M896 384q-204 0-381.5 69.5t-282 187.5-104.5 255q0 112 71.5 213.5t201.5 175.5l87 50-27 96q-24 91-70 172 152-63 275-171l43-38 57 6q69 8 130 8 204 0 381.5-69.5t282-187.5 104.5-255-104.5-255-282-187.5-381.5-69.5zm896 512q0 174-120 321.5t-326 233-450 85.5q-70 0-145-8-198 175-460 242-49 14-114 22h-5q-15 0-27-10.5t-16-27.5v-1q-3-4-.5-12t2-10 4.5-9.5l6-9 7-8.5 8-9q7-8 31-34.5t34.5-38 31-39.5 32.5-51 27-59 26-76q-157-89-247.5-220t-90.5-281q0-174 120-321.5t326-233 450-85.5 450 85.5 326 233 120 321.5z"/>),
    MONEY: (<g>
			<path d={longMessage `
					M500,225c-151.64,0-275,123.36-275,275s123.36,275,275,275s275-123.37,275-275S651.64,225,500,225z
					M500,742.16c-133.53,0-242.16-108.63-242.16-242.16c0-133.52,108.63-242.16,242.16-242.16S742.16,366.48,742.16,500
					C742.16,633.52,633.53,742.16,500,742.16z
				`}/>
			<path d={longMessage `
					M524.02,471.69c-36.46-13.73-51.48-22.74-51.48-36.89c0-12.01,9.01-24.02,36.89-24.02
					c30.88,0,50.62,9.86,61.77,14.58l12.44-48.47c-14.16-6.86-33.46-12.87-62.2-14.16v-37.75h-42.04v40.75
					c-45.9,9.01-72.5,38.61-72.5,76.36c0,41.61,31.31,63.06,77.21,78.51c31.74,10.72,45.47,21.02,45.47,37.32
					c0,17.16-16.73,26.6-41.18,26.6c-27.88,0-53.19-9.01-71.21-18.87l-12.87,50.19c16.3,9.44,44.18,17.16,72.92,18.44v40.75h42.04
					v-43.76c49.33-8.58,76.36-41.18,76.36-79.36C595.66,513.3,575.07,489.71,524.02,471.69z
				`}/>
		</g>),
    EMAIL: (<g transform="translate(0.000000,240.000000) scale(0.100000,-0.100000)" stroke="none">
			<path d={longMessage `
					M0 1200 l0 -900 1200 0 1200 0 0 900 0 900 -1200 0 -1200 0 0 -900z
					m2003 587 c-76 -62 -181 -147 -233 -189 -52 -42 -201 -162 -330 -267 -129
					-105 -237 -191 -240 -191 -3 0 -111 86 -240 191 -129 105 -278 225 -330 267
					-52 42 -157 127 -233 189 l-139 113 942 0 942 0 -139 -113z m-1565 -306 c116
					-95 212 -174 212 -177 0 -3 -18 -26 -39 -52 -22 -26 -120 -146 -217 -267 -97
					-121 -181 -224 -185 -230 -5 -5 -9 195 -9 454 0 369 3 461 13 454 6 -6 108
					-87 225 -182z m1760 -490 l-3 -230 -210 255 c-115 140 -216 263 -223 274 -12
					17 5 33 210 199 l223 181 3 -224 c1 -124 1 -328 0 -455z m-1191 29 c98 -79
					185 -144 193 -144 8 0 95 65 193 144 98 80 183 145 188 145 5 0 131 -148 280
					-330 l272 -330 -461 -3 c-253 -1 -671 -1 -927 0 l-467 3 268 332 c148 183 272
					332 276 330 4 -1 87 -67 185 -147z
				`}/>
		</g>),
    REGISTER: (<g>
			<path d={longMessage `
					M19.5 15c-2.483 0-4.5 2.015-4.5 4.5s2.017 4.5 4.5 4.5 4.5-2.015 4.5-4.5-2.017-4.5-4.5-4.5zm2.5
					5h-2v2h-1v-2h-2v-1h2v-2h1v2h2v1zm-7.18 4h-14.815l-.005-1.241c0-2.52.199-3.975 3.178-4.663 3.365-.777
					6.688-1.473 5.09-4.418-4.733-8.729-1.35-13.678 3.732-13.678 6.751 0 7.506 7.595 3.64 13.679-1.292
					2.031-2.64 3.63-2.64 5.821 0 1.747.696 3.331 1.82 4.5z
				`}/>
		</g>),
    QUICKPAY: (<g>
			<path d={longMessage `
					M22 4h-20c-1.104 0-2 .896-2 2v12c0 1.104.896 2 2 2h20c1.104 0 2-.896 2-2v-12c0-1.104-.896-2-2-2zm0 13.5c0
					.276-.224.5-.5.5h-19c-.276 0-.5-.224-.5-.5v-6.5h20v6.5zm0-9.5h-20v-1.5c0-.276.224-.5.5-.5h19c.276 0
					.5.224.5.5v1.5zm-9 6h-9v-1h9v1zm-3 2h-6v-1h6v1zm10-2h-3v-1h3v1z
				`}/>
		</g>)
};



// WEBPACK FOOTER //
// ./src/assets/scripts/constants/SvgIcons.tsx